"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActiveToInHouseHook = void 0;
/**
 * force active to in-house app
 */
class ActiveToInHouseHook {
    onActive(oneLink) {
        oneLink.params.forceDeepLink = true;
        const schema = oneLink.params.deepLink;
        if (schema) {
            const schemaURL = new URL(schema);
            if (schemaURL.host === 'snssdk2657') {
                schemaURL.host = 'snssdk2657test';
            }
            oneLink.params.deepLink = schemaURL.toString();
        }
    }
}
exports.ActiveToInHouseHook = ActiveToInHouseHook;
